export default {
  banner: {
    Authing就是身份云: "Authing は Identity Cloud です。",
    title: "",
    subtitle:
      "Authing はあらゆる Web、App、企業向けソフトウェアの認証とユーザー管理を迅速に実装し、顧客と従業員のための最も完全なログイン ソリューションを提供します。",
  },
  twoThing: {
    title: "Authing は、2 つの領域で支援します",
    subtitle: "main-twothings-subtitle中国石油、招行银行等多家世界 500 强都已部署 Authing 作为员工和用户的身份方案",
    "item-one": {
      title: "ユーザー Identity 管理",
      subtitle: "5行のコードで、顧客のための安全でシームレスな認証体験を実現します",
      "list-one": "統合されたサードパーティ ログイン",
      "list-two": "携帯電話番号の検証",
      "list-three": "多要素認証 MFA",
      "list-four": "シングルサインオン SSO",
      "list-five": "ユニバーサル・ログイン・フォーム・コンポーネント",
      "list-six": "カスタマイズされた認証プロセス",
    },
    "item-two": {
      title: "従業員 Identity 管理",
      subtitle: "開発なし、社内システムとの統合、従業員のアプリケーションのアイデンティティ権限と権限の統一管理",
      "list-one": "シングルサインオン SSO",
      "list-two": "多要素認証 MFA",
      "list-three": "プライベート展開のサポート",
      "list-four": "権限管理",
      "list-five": "メンバーの検証",
    },
  },
  advantage: {
    title: "Authing がもたらす3つの重要な価値",
    subtitle: "main-advance-subtitle Authing 让身份管理变得简单。",
    "item-one": {
      title: "開発コストの削減",
      descript:
        "Authing のアイデンティティセンターを使用することで、組織とユーザーの継続的な健全性が保証されます。 自社開発のソリューションを置き換えるにしても、既存のベンダーを置き換えるにしても、Authing を使用することは組織にとって良い選択です。",
    },
    "item-two": {
      title: "ログイン・セキュリティ",
      descript:
        "非対称的に暗号化された RSAと鍵インフラ KMS による暗号化されたストレージと伝送により、ユーザーのみがアクセスできるようにします。 すべての生データ。 カスタムパスワードの強度とパスワード暗号化アルゴリズム、さまざまなアンチバースト、悪意のある登録メカニズムをサポートします。",
    },
    "item-three": {
      title: "月間のセキュアログイン数",
      descript:
        "Authingを使用することで、システムのデカップリングを最大限に確保し、Serverless との組み合わせや既存のサービスとの組み合わせが容易になります。",
    },
  },
  IAM: {
    title: "適した IAM ソリューションを構築します",
    subtitle:
      "Authing Identity Cloud は、組織がコアビジネスに集中できるように、外部ユーザーアカウントと内部の従業員の権限を安全かつ効率的に管理することを支援します。",
    "item-one": {
      title: "シングルサインオン SSO",
      subtitle:
        "Authing シングルサインオンは、IDシステムを効率的に管理するのに役立ちます。 認可されたすべてのオフィスソフトウェア、ソーシャルプラットフォーム、オンプレミスシステムへのシングルサインオンアクセスは、ユーザーエクスペリエンスを大幅に向上させます。",
    },
    "item-two": {
      title: "ログイン コンポーネント",
      subtitle:
        "Authing ログインコンポーネントは、ログインロジックコードを書く負担を軽減し、数行のコードでログイン登録フォームを即座に生成します。 また、Authing SDK を使ってフォームをカスタマイズすることもできます。",
    },
    "item-tree": {
      title: "多要素認証",
      subtitle:
        "Authing 多要素認証は、SMS 認証コードログイン、メールボックス認証ログイン、指紋認証ログイン、QR コードスキャン認証ログインなどの認証方法に対応しています。",
    },
    "item-four": {
      title: "ユーザー管理",
      subtitle:
        "Authing ダッシュボードはユーザー情報管理、ユーザーの権利管理、ユーザーのセキュリティ情報監査、ユーザー データ分析、等を統合します。",
    },
  },
  industry: {
    title: "産業別ソリューション",
    subtitle:
      "企業の生産性を向上させるために、さまざまな産業やアプリケーション分野の専門的なソリューションを提供しています。",
    "item-one": {
      title: "政府",
      descript:
        "市民が1つのアカウントですべてのシステムにアクセスし、政府のサービスに安全にログインできるようにします。",
    },
    "item-two": {
      title: "出版",
      descript: "読者が読書に集中できるように、配信、著者、編集者、すべてが指先でできるようになります。",
    },
    "item-tree": {
      title: "金融",
      descript: "権限を与えられた金融クラウド、直観的で視覚的な分析プラットフォームは、国の規制基準に準拠しています。",
    },
    "item-four": {
      title: "ゲーム",
      descript:
        "プレイヤーを早く来させて、ハッカーをポイントから遠ざけましょう。複数の ID ソースからの迅速なログインにより、ユーザーの機密情報へのアクセスを確実にします。",
    },
  },
  code: {
    title: "五行コードで認証システムにアクセスする",
    subtitle:
      "Authing は開発者に優しいアイデンティティサービスを提供することに力を入れており、安全でエレガント、堅牢、柔軟性のある 統合されたソリューションを見つけることにこだわっています。  数十種類の SDK とクイックスタートチュートリアルを提供していますので、どのアプリケーションでも数分で使用を開始することができます。",
    other: "任意の技術スタックをサポートします",
  },
  other: {
    title: "企業にとってより良い製品やサービスを提供します",
    "item-one": {
      common:
        "“アイデンティティ認証、シングルサインオン、サーバレスコンピューティングなどの新技術において、Authing は非常に革新的です。”",
      author: "東南大学",
    },
    "item-two": {
      common: "“Authing は素晴らしい仕事をしてくれました。”",
      author: "AWS（亚马逊云计算服务）",
    },
    "item-three": {
      common: "“Authing とは、考えて作られた製品です。”",
      author: "高等教育出版社",
    },
    "title-cooperatner": "パートナー",
    brand: {
      "item-one": "main-other-logo-iso ISO 质量体系认证",
      "item-two": "main-other-logo-gdpr 通用数据保护条例",
      "item-tree": "main-other-logo-soc中国网络安全产业白皮书",
      "item-four": "main-other-logo-djcp三级保护",
    },
    slogn: "ワンステップでサインアップして、8000 個の無料認定をお楽しみください。",
  },
  1: "5行のコードで、顧客のための安全でシームレスな認証体験を実現します",
  2: "開発なし、社内システムとの統合、従業員のアプリケーションのアイデンティティ権限と権限の統一管理",
  3: "Authing のアイデンティティセンターを使用することで、組織とユーザーの継続的な健全性が保証されます。 自社開発のソリューションを置き換えるにしても、既存のベンダーを置き換えるにしても、Authing を使用することは組織にとって良い選択です。",
  4: "Authingを使用することで、システムのデカップリングを最大限に確保し、Serverless との組み合わせや既存のサービスとの組み合わせが容易になります。",
  5: "非対称的に暗号化された RSAと鍵インフラ KMS による暗号化されたストレージと伝送により、ユーザーのみがアクセスできるようにします。 すべての生データ。 カスタムパスワードの強度とパスワード暗号化アルゴリズム、さまざまなアンチバースト、悪意のある登録メカニズムをサポートします。",
  6: "Authing は開発者に優しいアイデンティティサービスを提供することに力を入れており、安全でエレガント、堅牢、柔軟性のある 統合されたソリューションを見つけることにこだわっています。  数十種類の SDK とクイックスタートチュートリアルを提供していますので、どのアプリケーションでも数分で使用を開始することができます。",
  7: "企業にとってより良い製品やサービスを提供します",
  8: "“Authing は素晴らしい仕事をしてくれました。”",
  9: "“アイデンティティ認証、シングルサインオン、サーバレスコンピューティングなどの新技術において、Authing は非常に革新的です。”",
  10: "“Authing とは、考えて作られた製品です。”",
  11: "Authing Identity Cloud IDaaS ユーザー管理サービスは統一されたアイデンティティとシングルサインオンを実現します",
  Authing就是身份云: "Authing は Identity Cloud です。",
  用户身份管理: "ユーザー Identity 管理",
  集成第三方登录: "統合されたサードパーティ ログイン",
  手机号码闪验: "携帯電話番号の検証",
  多因素认证MFA: "多要素認証 MFA",
  单点登录: "シングルサインオン SSO",
  通用登录组件: "ユニバーサル・ログイン・フォーム・コンポーネント",
  自定义认证流程: "カスタマイズされた認証プロセス",
  开发咨询: "開発コンサルティング",
  免费使用: "無料アクセス",
  联系我们: "お問い合わせ",
  员工身份管理: "従業員 Identity 管理",
  单点登录SSO: "シングルサインオン SSO",
  权限管理: "権限管理",
  支持私有化部署: "プライベート展開のサポート",
  成员号码闪验: "メンバーの検証",
  企业顾问: "アドバイザー",
  我们的合作伙伴: "パートナー",
  Authing的优势: "Authing がもたらす3つの重要な価値",
  "51%": "51%",
  降低开发成本: "開発コストの削減",
  "600万": "600 万",
  每月安全登录次数: "月間のセキュアログイン数",
  "99.99%": "99.99%",
  登录安全性: "ログイン・セキュリティ",
  提高生产力: "生産性を高める",
  高度安全: "高い安全性",
  查看更多优势: "メリットについてもっと詳しく",
  五行代码接入身份认证系统: "五行コードで認証システムにアクセスする",
  我该如何选择Authing的技术: "Authing の技術の選び方とは？",
  前往开发者社区: "デベロッパー コミュニティへ",
  了解更多企业故事: "企業ストーリーについて詳しく",
  部分客户: "一部のお客様",
  投资机构: "投資機関",
  东南大学: "東南大学",
  高等教育出版社: "高等教育出版社",
  "main-code-title": "五行コードで認証システムにアクセスする",
  "main-code-supports": "任意の技術スタックをサポートします",
  "main-code-subtitle":
    "Authing は開発者に優しいアイデンティティサービスを提供することに力を入れており、安全でエレガント、堅牢、柔軟性のある 統合されたソリューションを見つけることにこだわっています。  数十種類の SDK とクイックスタートチュートリアルを提供していますので、どのアプリケーションでも数分で使用を開始することができます。",

  构建适合你的IAM解决方案: "適した IAM ソリューションを構築します",
  登录组件: "ログイン コンポーネント",
  多因素认证: "多要素認証",
  用户管理: "ユーザー管理",
  "main-iam-subtitle":
    "Authing Identity Cloud は、組織がコアビジネスに集中できるように、外部ユーザーアカウントと内部の従業員の権限を安全かつ効率的に管理することを支援します。",
  "main-iam-sso-subtitle":
    "Authing シングルサインオンは、IDシステムを効率的に管理するのに役立ちます。 認可されたすべてのオフィスソフトウェア、ソーシャルプラットフォーム、オンプレミスシステムへのシングルサインオンアクセスは、ユーザーエクスペリエンスを大幅に向上させます。",
  "main-iam-logincomp-subtitle":
    "Authing ログインコンポーネントは、ログインロジックコードを書く負担を軽減し、数行のコードでログイン登録フォームを即座に生成します。 また、Authing SDK を使ってフォームをカスタマイズすることもできます。",
  "main-iam-multiple-subtitle":
    "Authing 多要素認証は、SMS 認証コードログイン、メールボックス認証ログイン、指紋認証ログイン、QR コードスキャン認証ログインなどの認証方法に対応しています。",
  "main-iam-usermanage-subtitle":
    "Authing ダッシュボードはユーザー情報管理、ユーザーの権利管理、ユーザーのセキュリティ情報監査、ユーザー データ分析、等を統合します。",
  "main-industry-solutions": "産業別ソリューション",
  "main-industry-solutions-subtitle":
    "企業の生産性を向上させるために、さまざまな産業やアプリケーション分野の専門的なソリューションを提供しています。",
  "main-industry-government": "政府",
  "main-industry-government-subtitle":
    "市民が1つのアカウントですべてのシステムにアクセスし、政府のサービスに安全にログインできるようにします。",
  "main-industry-publish": "出版",
  "main-industry-publish-subtitle":
    "読者が読書に集中できるように、配信、著者、編集者、すべてが指先でできるようになります。",
  "main-industry-finance": "金融",
  "main-industry-finance-subtitle":
    "権限を与えられた金融クラウド、直観的で視覚的な分析プラットフォームは、国の規制基準に準拠しています。",
  "main-industry-game": "ゲーム",
  "main-industry-game-subtitle":
    "プレイヤーを早く来させて、ハッカーをポイントから遠ざけましょう。複数の ID ソースからの迅速なログインにより、ユーザーの機密情報へのアクセスを確実にします。",

  "main-other-title": "企業にとってより良い製品やサービスを提供します",
  "main-other-cooperatner": "パートナー",
  "main-other-register": "ワンステップでサインアップして、8000 個の無料認定をお楽しみください。",
  "button-立即试用": "直ちに試用する",
  "button-查看详情": "詳細を表示",
  "button-开发咨询": "開発コンサルティング",
  "button-查看更多": "もっと見る",
  "button-开发者社区": "コミュニティを開発する",
};
